import React from "react";
import DKFormInputLabelContainer from "../widgets/formVariablesWidget/formInputContainer/DKFormInputLabelContainer";
import {
  ToggleButtonGroup,
  ToggleButton,
  styled,
  ToggleButtonProps,
  Typography,
  ThemeProvider,
} from "@mui/material";
import { uid } from "../../../helpers/utilsTS";
import { globalDkMUITheme } from "../../../globalMUITheme";

type Value = string | number | boolean;

type DKFormToggleButtonGroupProps = {
  dataTestId?: string;
  label: string;
  items: { dataTestId?: string; value: Value; label: string }[];
  selectedValue: Value;
  onChange: (value: Value) => void;
};

const DKFormToggleButtonGroup = ({
  dataTestId,
  label,
  items,
  selectedValue,
  onChange,
}: DKFormToggleButtonGroupProps) => {
  const DKToggleButton = styled(ToggleButton)<ToggleButtonProps>(
    ({ theme }) => ({
      minWidth: "150px",
      fontWeight: 400,
      fontSize: "15px",
      lineHeight: "20px",
      color: theme.palette.tertiary.darker,
      textTransform: "none",
      borderRadius: "0px",

      "&.Mui-selected": {
        backgroundColor: theme.palette.secondary.light,
        border: `1px solid ${theme.palette.secondary.darker}`,

        "&:hover": {
          backgroundColor: theme.palette.secondary.lighter,
          border: `1px solid ${theme.palette.secondary.main}`,
        },
      },

      "&:hover": {
        backgroundColor: theme.palette.secondary.lighter,
        border: `1px solid ${theme.palette.secondary.main}`,
      },
    })
  );

  return (
    <ThemeProvider theme={globalDkMUITheme}>
      <DKFormInputLabelContainer label={label}>
        <ToggleButtonGroup
          data-testid={dataTestId}
          value={selectedValue}
          exclusive
          onChange={(_event, value: Value) => {
            onChange(value);
          }}
        >
          {items.map((item) => {
            return (
              <DKToggleButton
                data-testid={item.dataTestId}
                value={item.value}
                key={uid.rnd()}
                disabled={item.value === selectedValue}
              >
                <Typography>{item.label}</Typography>
              </DKToggleButton>
            );
          })}
        </ToggleButtonGroup>
      </DKFormInputLabelContainer>
    </ThemeProvider>
  );
};

export default DKFormToggleButtonGroup;
